"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$common, _theme$transitions, _theme$transitions$ea, _theme$transitions2, _theme$transitions2$d, _theme$palette2, _theme$palette2$commo, _theme$palette3, _theme$palette3$commo;

  return {
    root: {
      bottom: theme.spacing(3),
      display: "flex",
      justifyContent: "center",
      left: 0,
      position: "absolute",
      right: 0,
      zIndex: 3
    },
    bullet: {
      background: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$common = _theme$palette.common) === null || _theme$palette$common === void 0 ? void 0 : _theme$palette$common.white,
      borderRadius: theme.spacing(3),
      cursor: "pointer",
      display: "flex",
      height: theme.spacing(1.5),
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      opacity: 0.35,
      transition: theme.transitions.create("all", {
        easing: (_theme$transitions = theme.transitions) === null || _theme$transitions === void 0 ? void 0 : (_theme$transitions$ea = _theme$transitions.easing) === null || _theme$transitions$ea === void 0 ? void 0 : _theme$transitions$ea.easeInOut,
        duration: (_theme$transitions2 = theme.transitions) === null || _theme$transitions2 === void 0 ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) === null || _theme$transitions2$d === void 0 ? void 0 : _theme$transitions2$d.shorter
      }),
      width: theme.spacing(1.5),
      "&:hover": {
        background: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$commo = _theme$palette2.common) === null || _theme$palette2$commo === void 0 ? void 0 : _theme$palette2$commo.white,
        opacity: 1
      }
    },
    bulletSelected: {
      background: (_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : (_theme$palette3$commo = _theme$palette3.common) === null || _theme$palette3$commo === void 0 ? void 0 : _theme$palette3$commo.white,
      opacity: 1
    }
  };
});
var _default = styles;
exports.default = _default;